import { render } from "./PlanLimitNotice.vue?vue&type=template&id=3475e1dc&scoped=true"
import script from "./PlanLimitNotice.vue?vue&type=script&lang=js"
export * from "./PlanLimitNotice.vue?vue&type=script&lang=js"

import "./PlanLimitNotice.vue?vue&type=style&index=0&id=3475e1dc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3475e1dc"]])

export default __exports__